import { useMutation as useBaseMutation } from "@edreamsodigeo/frontend-api-client-base";
import { GqlObj } from "../gql-tag/types";
import { UseMutationOptions, UseMutationResult, Variables } from "./types";

/**
 * Returns a mutate function to perform a graphql mutation to frontend-api.
 * After mutation, the queries will be refeched
 *
 * @remarks
 * You can customize the mutation with graphql operation directives:
 * - \@silent: Avoid perform queries after mutation
 * - \@update_groups(groups: "groupName1,groupName2"): Perform query after mutations only if mutation and query have a match in update groups
 *
 * @param query - Graphql mutation operation, builded with gql constructor
 *
 * @returns Mutate function, Mutation response and current status of the mutation
 */
export function useMutation<
  TData,
  TVariables extends Variables | undefined = undefined
>(
  query: GqlObj,
  options: UseMutationOptions<TData, TVariables> = {}
): UseMutationResult<TData, TVariables> {
  return useBaseMutation(query, options);
}
